import { ROUTER } from '@core/constants/router.constants';
import dateHelper from '@core/helpers/dateHelper';
import { BreadcrumbService } from '@policoders/ds';
import { useService, useStore } from '@policoders/di';
import HideConditional from '@shared/components/hide-conditional';
import Loading from '@shared/components/loading';
import PageHeader from '@shared/components/page-header';
import { Table, TableBody, TableHeader, TableLine } from '@shared/old-table';
import { useEffect } from 'react';

import patientService from './patient.service';
import { PatientStore } from './patient.store';

export const PatientsPage = () => {
  const store = useStore<PatientStore>('PatientStore');

  useEffect(() => store.getItems(), [store]);

  // const handleRemove = (id: string) => {
  //   removeItem(id).then(({ type, message }) => setMessage(type, message));
  // };

  const breadcrumb = useService<BreadcrumbService>('BreadcrumbService');
  useEffect(() => {
    breadcrumb.set([{ label: 'Pacientes', value: ROUTER.HEALTH.PATIENTS.INDEX }]);
  }, [breadcrumb]);

  return (
    <>
      <PageHeader
        title="Pacientes"
        actions={[{ title: 'Novo', url: ROUTER.HEALTH.PATIENTS.NEW }]}
      />
      <Loading active={store.loading_items} />

      <HideConditional condition={store.loading_items}>
        <Table>
          <TableHeader
            classList={[null, null, 'text-center', 'text-end', null]}
            columns={['Nome', 'Profissão', 'Idade', 'Último atendimento']}
          />
          <TableBody>
            {store.items?.map((it, i) => (
              <TableLine
                key={i}
                id={it.id}
                linkTo={`/health/patients/${it.id}`}
                classList={[null, null, 'text-center', 'text-end', null]}
                values={[
                  it.name,
                  it.occupation,
                  patientService.getAge(it.birth_date),
                  `${dateHelper.format(new Date(it.createdAt), 'dd/MM/yyyy hh:mm:ss')}`,
                ]}
                // onRemovePress={handleRemove}
              />
            ))}
          </TableBody>
        </Table>
      </HideConditional>
    </>
  );
};
